/** True when Wialon returned a numeric battery % (cart-powered units are often null). */
export const hasNumericBatteryLevel = (level) =>
  level !== null &&
  level !== undefined &&
  level !== '' &&
  !Number.isNaN(Number(level));

export const isLowBattery = (level, threshold = 40) =>
  hasNumericBatteryLevel(level) && Number(level) < threshold;

export const formatBatteryLevel = (level) =>
  hasNumericBatteryLevel(level) ? `${Number(level)}%` : '—';

/** Row / option styling; no highlight when level is unknown (null). */
export const getBatteryLevelStyle = (level) => {
  if (!hasNumericBatteryLevel(level)) {
    return { backgroundColor: '#8898aa' };
  }
  const n = Number(level);
  if (n <= 30) return { backgroundColor: '#f5365c' };
  if (n <= 60) return { backgroundColor: '#fb6340' };
  return { backgroundColor: '#2dce89' };
};

/** Bootstrap row class for GPS Tracker table; neutral when no numeric level. */
export const getBatteryTableRowClass = (level) => {
  if (!hasNumericBatteryLevel(level)) {
    return '';
  }
  const n = Number(level);
  if (n <= 30) return 'bg-danger text-white';
  if (n <= 60) return 'bg-warning text-white';
  return 'bg-success text-white';
};
